import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/EmbedFrame/EmbedFrame.js
const EmbedFrame = createSectionForm({
  icon: "window-line",
  title: "Embedded Page / Form",
  fields: [
    {
      name: "url",
      label: "URL",
      placeholder: "https://apps.infotainment.com/customers/requests/new",
      fullWidth: true,
    },
    { name: "title", label: "Title (accessibility)" },
    { name: "min_height", label: "Minimum Height (px)", type: "number", defaultValue: 750 },
  ],
});

export default EmbedFrame;
